/**
 * out of stock button and favorite icon to be displayed as greyed out add to bag along with tag out of stock
 *
 * @module views/components/OutOfStockFavorite
 * @memberof -Common
 */
import './OutOfStockFavorite.scss';

import React from 'react';

import PropTypes from 'prop-types';

import AsyncComponent from '@ulta/core/components/AsyncComponent/AsyncComponent';
import Button from '@ulta/core/components/Button/Button';

import Tag from '@ulta/modules/Tag/Tag';

/**
 * Represents a OutOfStockFavorite component
 *
 * @method
 * @param {OutOfStockFavoriteProps} props - React properties passed from composition
 * @returns OutOfStockFavorite
 */
export const OutOfStockFavorite = function( props ){
  const {
    comingSoon,
    addToBagAction,
    id,
    invokeMutation,
    bookmarkAction,
    bookmarked,
    commerceId,
    productId,
    quantity,
    removeBookmarkAction,
    skuId,
    state
  } = props;

  return (
    <div className='OutOfStockFavorite'>
      <div className='OutOfStockFavorite__Container'>

        <Button
          className='OutOfStockFavorite__Container__button'
          disabled={ true }
          label={ addToBagAction?.label }
          variant={ 'primary' }
          ariaLabel={ addToBagAction?.label }
        />
        <AsyncComponent
          id={ id }
          invokeMutation={ invokeMutation }
          bookmarkAction={ bookmarkAction }
          bookmarked={ bookmarked }
          commerceId={ commerceId }
          key='ProductBookmark'
          moduleName='ProductBookmark'
          productActionsProps={ props }
          productId={ productId }
          quantity={ quantity }
          removeBookmarkAction={ removeBookmarkAction }
          skuId={ skuId }
          state={ state }
        />
      </div>

      { props.outOfStockLabel &&
        <div className='OutOfStockFavorite__Error'>
          <Tag
            variant='utility'
            style='warning'
            message={ props.outOfStockLabel }
          />
        </div>
      }
      { comingSoon && (
        <div className='OutOfStockFavorite__comingSoon'>
          <Tag
            variant='utility'
            style='notification'
            message={ comingSoon.comingSoonMessage }
          />
        </div>
      ) }
    </div>
  );
};

/**
 * Property type definitions
 *
 * @typedef OutOfStockFavoriteProps
 * @type {object}
 * @property {object} addToBagAction - Sets label and graphql
 * @property {string} outOfStockLabel - Label for "Out of stock"
 * @property {boolean} bookmarked - True/False value for the bookmarked
 * @property {object} removeBookmarkAction - Label and graphql string for removal from favorite
 * @property {object} bookmarkAction - Label to be displayed and graph string
 */

export const propTypes =  {
  addToBagAction: PropTypes.shape( {
    label: PropTypes.string
  } ),
  outOfStockLabel: PropTypes.string,
  bookmarked: PropTypes.bool,
  removeBookmarkAction: PropTypes.shape( {
    label: PropTypes.string,
    graphql: PropTypes.string
  } ),
  bookmarkAction: PropTypes.shape( {
    label: PropTypes.string,
    graphql: PropTypes.string
  } )
};


OutOfStockFavorite.propTypes = propTypes;

export default OutOfStockFavorite;
